import { Box, Typography } from "@mui/material";
import { STATUS_ICON } from "./runStepStatusIcons";
import type { WorkflowRun } from "./workflow.types";

/** The per-step breakdown of a single WorkflowRun — shared by the live RunSummaryPanel and RunHistoryPanel. */
export default function RunStepList({ run }: { run: WorkflowRun }) {
  if (run.steps.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No steps recorded for this run yet.
      </Typography>
    );
  }

  return (
    <>
      {run.steps.map((step) => (
        <Box key={step.stepId} sx={{ mb: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {STATUS_ICON[step.status]}
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              {step.label}
            </Typography>
          </Box>
          {step.verdict && (
            <Typography variant="body2" sx={{ mt: 0.5 }}>
              Verdict:{" "}
              <strong>
                {step.verdictLabel || (step.verdict === "yes" ? "Yes" : step.verdict === "no" ? "No" : step.verdict)}
              </strong>
            </Typography>
          )}
          {step.reasoning && (
            <Typography variant="caption" color="text.secondary" display="block">
              {step.reasoning}
            </Typography>
          )}
          {step.error && (
            <Typography variant="body2" color="error.main" sx={{ mt: 0.5 }}>
              {step.error}
            </Typography>
          )}
          {!step.error && step.result != null && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", mt: 0.5, wordBreak: "break-word" }}
            >
              {typeof step.result === "string" ? step.result : JSON.stringify(step.result)}
            </Typography>
          )}
        </Box>
      ))}
    </>
  );
}
